import React, { useEffect, useState ,useRef } from 'react';
import { SBTreeView } from '../../../../UiComponents/SBTreeView'
import { Accordion } from 'react-bootstrap';
import { LoadingScreen } from '../../../../UiComponents/LoadingComponent';
import { getBillingGetExistingInvoiceAPI, getBillingGetExistingClientsAPI, getBillingDocs,getinvoiceData,insertInvoiceApproval,updateInvoiceApproval,getbillingInvoiceadjustment,insertClientBillingApproval,deleteBillingApproval,updatebillingApproval,saveinvoicepdfdoc,saveBillingpdfdoc,insertOrUpdateActivityDetails,updateBillingdocstatus,updateInvoiceDocument,getpdfbillingReport,getpdfinvoiceReport,DownloadDocument,getClientBillingFee} from "../../../../../config/apiConfig";
import { sbaAxios } from '../../../../utils/sbaAxios';
import { SBDatePicker } from '../../../../UiComponents/SBDatePicker';
import { SBADropDown } from '../../../../UiComponents/SBADropDown';
import moment from "moment";
import { AgGridReact } from 'ag-grid-react';
import { SBNotify } from "../../../../utils/sbNotify";
import { Modal } from "react-bootstrap";
import { UrlPath } from '../../../../../config/routeConfig';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SBACurrencyInput } from "../../../../UiComponents/SBACurrencyInput";
import { CurrencyFormat } from "../../../../utils/currencyFormattter";
import Excel2_24px from "../../../../../../src/Images/Excel2_24px.png";
import PDFMedium from "../../../../../../src/Images/PDFMedium.png";
import { getPercentageFormat } from '../../../../utils/conversionMethods';
import { ToastContainer } from 'react-toastify';
export const Generate = () => {
  const [billingList,setBillingList]=useState([]);
  const [isBillingLoading,setIsBillingLoading]=useState(true);
  const [showAccordian, setShowAccordian] = useState(true);
  const [endDate, setEndDate] = useState(moment(new Date()));
  const [clientBillingId, setClientBillingId] = useState(0);
  const [billingResponse, setBillingResponse] = useState(null);
  const isInitialLoad = useRef(true);
  const [contactId,setContactId]=useState(0);
  const  [selectedIsBilling,setselectedIsBilling]=useState(true);
  const  [selectedIsInvoice,setselectedIsInvoice]=useState(false);
  const [invoiceId,setInvoiceId]=useState(0);
  const [selectedtype,setselectedType]=useState("billing");
  const [isSectionLoading,setIsSectionLoading]=useState(false);
  const [render,setRender]=useState(true);
  const [billingName,setBillingName]=useState();


  useEffect(() => {
    if (isInitialLoad.current) {
      getFamilyData();
        isInitialLoad.current = false;
    }
}, []);

  const handleShowAccordian = () => {
    setShowAccordian(!showAccordian)
  }
  const handleEndDate = (value) => {
    value?setEndDate(value): setEndDate(null);
  }
  const handleClientBillingChange = (value, cId, type, invoiceId,billingname) => {
    setIsSectionLoading(true);
    setTimeout(() => {
      setClientBillingId(value);
      setInvoiceId(invoiceId);
      setContactId(cId);
      setselectedType(type);
      setBillingName(billingname);
     
      if (type == "billing") {
        setEndDate(moment(new Date()));
        if(!showAccordian)
        {
        getDocuments(value);
        }
        setselectedIsBilling(true);
        setselectedIsInvoice(false);
      }
      else {
        if(!showAccordian)
        {
        getInvoiceDetails(value,invoiceId);
        }
        setselectedIsBilling(false);
        setselectedIsInvoice(true);
      }
      setIsSectionLoading(false);
    }, 500);
    
  };

  const handleBillingResponse = (value) => {
    setBillingResponse(value);
  };

  const getFamilyData = (searchText) => {
    const keyWord = searchText ? `/${searchText}` : ``
    sbaAxios({ url: `${getBillingGetExistingClientsAPI}` }).then(res => {
      sbaAxios({ url: `${getBillingGetExistingInvoiceAPI}` }).then(invoice => {
        setBillingList(res.map(billing => {
          const filteredInvoice=invoice.filter(item=>item.ClientBillingId==billing.ClientBillingId).map(cs=>({ ...cs, selected: false, text: cs.InvoiceName, ClientBillingId: billing.ClientBillingId, checked: false, type: 'Invoice' }));
          return{ ...billing, text: billing.ClientBillingName, checked: false, type: 'billing', expanded: false, selected: false, items: filteredInvoice }}));
      });
      //billing.ClientStatements.map(cs => (
      setIsBillingLoading(false);
    }).catch(()=>{
         setBillingList([]);
      setIsBillingLoading(false);
    });
  };

  const getDocuments = async(bId) => {
    try{
      const response = await sbaAxios({
        url: getBillingDocs,
        params:{
          billingDate: new Date(endDate),
          clientBillingId: bId
        }
      });
     
      handleBillingResponse(response);
    }
    catch(e){
      handleBillingResponse(null);
    }
  };

  const getInvoiceDetails = async(bId,invcId) => {
    try{
      const response = await sbaAxios({
       
        url: `${getinvoiceData}${bId},${invcId},${new Date(endDate)}` ,
      });
      handleBillingResponse(response);
    }
    catch(e){
      handleBillingResponse();
    }
  }
  return (
    <div className='row'>
      <div className='col-12 col-md-2'>
      {isBillingLoading ? <><LoadingScreen/></> : <InvestorTreeSection billing={billingList} handleClientBillingChange={handleClientBillingChange}></InvestorTreeSection>}
      </div> 

      {isSectionLoading ? <div className='col'><LoadingScreen /></div> :
        <>
          {selectedIsBilling &&
            <div className='col'>
              <div className='detail h-100'><GenerateBillSection  billingDatee={endDate} setRender={setRender} clientBillingId={clientBillingId} billingName={billingName} contactId={contactId} handleShowAccordian={handleShowAccordian} showAccordian={showAccordian} handleEndDate={handleEndDate} billingResponse={billingResponse} /></div>
            </div>}
          {selectedIsInvoice && <div className='col'>
            <div className='detail h-100'><InvoiceBillSection billingDatee={endDate} setRender={setRender} invoiceId={invoiceId} contactId={contactId} handleShowAccordian={handleShowAccordian} showAccordian={showAccordian} handleEndDate={handleEndDate} billingResponse={billingResponse} /></div>
          </div>
          }
          {
            showAccordian &&
            <div className='col-12 col-md-3 xp-2'>
              <div className='detail h-100'><AccordionSection render={render} endDate={endDate} clientBillingId={clientBillingId} invoiceId={invoiceId} type={selectedtype} handleBillingResponse={handleBillingResponse} /></div>
            </div>
          }</>}
        </div>
  )
}
const InvestorTreeSection = ({ billing, handleClientBillingChange}) => {
  const [billingList,setBillingList]=useState(billing);
  const [billingSearchText,setBillingSearchText]=useState("");
  useEffect(()=>{
    setBillingList(billing);
  },[billing])
  const afterExpand = (e) => {
    setBillingList(fl => (fl.map(item => {
      if (item.ClientBillingId === e.item.ClientBillingId) {
        return { ...item, expanded: !e.item.expanded }
      }
      else return { ...item }
    })));
  };
  const filterFamilyList = (e) => {
    const text = e?.target?.value || "";
    setBillingSearchText(text);
    if (text.length > 0) {
      setBillingList(billing.filter(item => (item.ClientBillingName.toLowerCase().includes(text.toLowerCase()))))
    }
    else {
      setBillingList(billing);
    }
  };
  return <>
    <div
      className="detail p-2"
      style={{ height: '60vh', overflowY: 'scroll' }}
    >
      <div>
        <label className="mb-1 label">Billing Search</label>
        <input
          className="form-control"
          type="text"
          value={billingSearchText}
         onChange={(e) => { filterFamilyList(e) }}
        />
      </div>
      <SBTreeView
        data={billingList}
        expandIcons={true}
        onExpandChange={(e) => { afterExpand(e) }}
        checkboxes={false}
        aria-multiselectable={true}
        onItemClick={(e) => { handleClientBillingChange(e.item.ClientBillingId,e.item.ContactId,e.item.type,e.item.InvoiceId,e.item.ClientBillingName) }}
      />
    </div>
  </>
};
const GenerateBillSection = ({setRender,clientBillingId,billingDatee,contactId,billingName,handleShowAccordian, showAccordian, handleEndDate, billingResponse}) => {
  const [statusList,setstatusList] =useState([
    {statusId: 0, statusName:"--Select--"},
    {statusId: 1, statusName:"Pending"},
    {statusId: 2, statusName:"Reviewed"},
    {statusId: 3, statusName:"Approved"}
  ])
  const [billingDate, setBillingDate] = useState(billingDatee);
  const [selectedStatus, setSelectedStatus] = useState(statusList[0]);
  const [isSaveshow,setisSaveshow]=useState(false);
  const [showtext,setShowText]=useState(false);
  const [billingApprovalId,setbillingApprovalId]=useState(0);
  const[showDeleteModal,setshowDeleteModal]=useState(false);
  const history = useNavigate();
  
  useEffect(() => {
    if (billingResponse?.ApprovalDetails?.BillingApprovalId >0) {
      setShowText(true);
    
       if (billingResponse?.ApprovalDetails?.ApprovalStatus == "Pending") {
       
                    setstatusList( [{statusId: 0, statusName:"--Select--"},
                    //{statusId: 1, statusName:"Pending"},
                    {statusId: 2, statusName:"Reviewed"},
                    {statusId: 3, statusName:"Approved"}]);
                } else if (billingResponse?.ApprovalDetails?.ApprovalStatus  == "Review") {
                  setstatusList([ {statusId: 0, statusName:"--Select--"},
                  //{statusId: 1, statusName:"Pending"},
                 // {statusId: 2, statusName:"Reviewed"},
                  {statusId: 3, statusName:"Approved"}]);
                } else if (billingResponse?.ApprovalDetails?.ApprovalStatus  == "Approve") {
                  setstatusList([ {statusId: 0, statusName:"--Select--"}])
                } else {
                  setstatusList([ {statusId: 0, statusName:"--Select--"},
                {statusId: 1, statusName:"Pending"},
                  {statusId: 2, statusName:"Reviewed"},
                  {statusId: 3, statusName:"Approved"}]);
                }

     
      setbillingApprovalId(billingResponse?.ApprovalDetails?.BillingApprovalId);
     setSelectedStatus({statusId: 0, statusName:"--Select--"});
    }
    else
    {
      setShowText(false);
      setstatusList([
        {statusId: 0, statusName:"--Select--"},
        {statusId: 1, statusName:"Pending"},
        {statusId: 2, statusName:"Reviewed"},
        {statusId: 3, statusName:"Approved"}
      ]);
      setbillingApprovalId(0);
      setSelectedStatus(statusList[0]);
    }
}, [billingResponse]);
  const handleSelectedStatus = (e) => {
    setSelectedStatus(e.value);
    if(e.value.statusId>0)
    setisSaveshow(true);
    else
    setisSaveshow(false);
  }
 const saveClientBillingApproval=()=>
 {
  if(billingResponse?.ApprovalDetails?.BillingApprovalId ==0)
  insertorupdateclientbillingapproval();
  else
  {
  updatebillingapprovalStatus();
  if(selectedStatus.statusId==3)
      updateDocumentStatus(61,billingResponse?.ApprovalDetails?.DocumentId,0);
  }
  setRender(value => !value);
       
 }

 const insertorupdateclientbillingapproval=()=>
 {
  var date = billingDate;
  var month = new Date(date).getMonth() + 1;
  var quarter = 0;

  if (month == 1 || month == 2 || month == 3)
      quarter = 1;
  else if (month == 4 || month == 5 || month == 6)
      quarter = 2;
  else if (month == 7 || month == 8 || month == 9)
      quarter = 3;
  else if (month == 10 || month == 11 || month == 12)
      quarter = 4;
const data={
  BillingApprovalId: billingResponse?.ApprovalDetails?.BillingApprovalId || 0,
  ClientBillingId: clientBillingId,
  BillingQuarter: quarter ,
  BillingYear:new Date(date).getFullYear() ,
  ApprovalStatusId: selectedStatus.statusId,
  ContactId: contactId,
  Notes: null,
  BillingQuarterTotal: billingResponse?.ApprovalDetails?.BillingQuarterTotal ,
  BillingGrossFee: billingResponse?.ApprovalDetails?.BillingGrossFee,
  BillingCredits: billingResponse?.ApprovalDetails?.BillingCredits,
  BillingAssets: billingResponse?.ApprovalDetails?.BillingAssets,
  BillingPpliCredits : billingResponse?.ApprovalDetails?.BillingPpliCredits ||[],
}

sbaAxios({
  url: `${insertClientBillingApproval}`,
  method: "post",
  data: data,
})
  .then(async (response) => {
      if (response) {
        SBNotify({
          type: "success",
          Msg: "Client Billing Approval saved Successfully",
        });
          setSelectedStatus(statusList[0]);
          setisSaveshow(false);
         const docResponse= await sbaAxios({
            url: getBillingDocs,
            params:{
              billingDate:billingDate.toISOString(),
              clientBillingId: clientBillingId
            }
          });
          const billingdocs=docResponse?.summnaryDocuments.filter(item => item.DocumentId != null && item.DocumentId != 0 && item.DocumentName); 
          if(billingdocs.length>0)
          {
            const filename= billingdocs[billingdocs.length-1].DocumentName.slice(0, billingdocs[0].DocumentName.lastIndexOf('.')) || billingName
            SaveBillingDocument(response,filename);
          }
          else 
          {
            SaveBillingDocument(response,billingName);
          }
      } else {
          SBNotify({
              type: "error",
              Msg: `Failed to Update`,
          });
      }
  })
  .catch(() => { });
 }

 const updatebillingapprovalStatus=()=>
 {
  
  sbaAxios({ url: `${updatebillingApproval}${billingApprovalId},${selectedStatus.statusId}`, method: 'get' })
  .then((repos) => {  
    SBNotify({
      type: "success",
      Msg: "Client Billing Approval  status updated Successfully",
  }); 
  setshowDeleteModal(false);
  setisSaveshow(false);
 
  })
  .catch((error) => {
    SBNotify({
      type: "error",
      Msg: `failed to update`,
  });
  });
 }
 const updateDocumentStatus=(statusId,docId,billingApprovalid)=>
 {
  
 
  sbaAxios({ url: `${updateBillingdocstatus}${billingApprovalid},${docId},{0},${statusId}`
   , method: 'get' })
  .then((repos) => {  
  })
  .catch((error) => {
    SBNotify({
      type: "error",
      Msg: `failed to update document status`,
  });
  });
 }
 const deleteClientBillingApproval=()=>
 {
  if (billingApprovalId == 0) {
    SBNotify({
      type: "error",
      Msg: `Please Save the Billing Summary before Delete`,
  });
  setshowDeleteModal(false);
  setSelectedStatus(statusList[0]);
}
else{
  setshowDeleteModal(true);
}
 }
 const deleteBillingapproval=()=>
 {
 
  sbaAxios({ url: `${deleteBillingApproval}${billingApprovalId}`, method: 'get' })
      .then((repos) => {  
        SBNotify({
          type: "success",
          Msg: "Client Billing Approval Deleted Successfully",
      }); 
      setshowDeleteModal(false);
      setRender(val=>!val);
      })
      .catch((error) => {
        SBNotify({
          type: "error",
          Msg: `failed to update Delete`,
      });
      setRender(val=>!val);
      });
 };
 const SaveBillingDocument= (billingApprovalid,DocumentName)=>
 {
   const activityXRefs=[];
    activityXRefs.push(
     {
         activityXRefId: 0,
         activityId: 0,
         activityEntityTypeId:0,
         activityEntityType: "Contact",
         entityId: contactId,
         entityName:"",
     })
   const data = {
     "activitySummary": {
         "activityId": 0,
         "activitySourceId": 2,
         "activityTypeId": 2,
         "activitySubTypeId": 50,
         "activityName": DocumentName,
         "activityDescription":  null,
         "activityDescriptionHtml":  null,
         "activityDate": billingDate,
         "documentStatusId": 0
     },
     "activityDetails":
     {
 
         "activityDetailId": 0,
         "activityId": 0,
         "emailMessageId": "",
         "emailFrom": "",
         "emailTo": "",
         "mailCc": "",
         "emailSubject": "",
         "emailBody": "",
         "emailBodyHtml": "",
         "emailDate": billingDate,
         "meetingDate": billingDate,
     },
     "activityXRefs": activityXRefs,
     "modifiedBy": 0
   }
     
      sbaAxios({
       url: `${insertOrUpdateActivityDetails}`,
       method: "post",
       data: data,
   })
   .then((response) => {
     if (response > 0) {
      savedoc(response,billingApprovalid)
     }
    
     })
     .catch((error) => {
         console.error(error);
     });
    
 };
 const savedoc= async (response,billingApprovalid)=>
 {
  setRender(true);
     const id = await savepdfdoc(response,billingApprovalid);
         setRender(value => !value);
       
 }
 const savepdfdoc=(response,billingApprovalid)=>
 {
  
sbaAxios({
    url:saveBillingpdfdoc,
    params:{
      ActivityId: response,
      BillingId: clientBillingId,
      ClientBillingName: billingName,
      BillingDate: moment(billingDate).format("MM-DD-yyyy") 
    },
    method:'GET',
  })
  .then((response) => {
    if (response > 0) {
      if(billingResponse?.ApprovalDetails?.DocumentId==0)
      updateDocumentStatus(62,response,billingApprovalid);
        setRender(value => !value);
    return response
    }
   else
   {
    setRender(value => !value);
   }
    })
    .catch((error) => {
        console.error(error);
       
    });
    
 }
 const openPreview=()=>{
  const url=`${UrlPath.BillingPreview}${clientBillingId}/${moment(billingDate).format("MM-DD-yyyy")}`;
  window.open(url,'_blank', 'rel=noopener noreferrer')
};
const GetInvoiceDateQuarterText =  ()=> {
  const quarters = ["1st", "2nd", "3rd", "4th"];
  var invDate = new Date(billingDate);
  var quarterNbr = Math.floor((invDate.getMonth() + 3) / 3);
  return quarters[quarterNbr - 1];
}

const downloadexcel=async()=>
{
  if (clientBillingId === 0) {
    SBNotify({
      type: "error",
      Msg: `Please Select the Billing Client`,
  });
   
}
else {
    try {     
if(billingResponse?.ApprovalDetails?.DocumentId==0)
{
  const fileName = billingResponse?.ApprovalDetails?.ClientBillingName + " " + GetInvoiceDateQuarterText() + " " + billingDate.getFullYear() + ".xls";
        await sbaAxios({
            url: getpdfbillingReport,
            params: {
              BillingId: clientBillingId,
              ClientBillingName: billingName ,
              BillingDate: billingDate,
            },
            method: 'GET',
            responseType: 'blob'
        }).then((response) => {
            const blobUrl = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Revoke the blob URL to free up memory
            window.URL.revokeObjectURL(blobUrl);

        })
      }
      else{
        const documentExtension = ".xls";
        const nameWithoutExtension = getFilenameWithoutExtension(billingResponse?.ApprovalDetails?.DocumentName);
        const encodedDocumentId = btoa(billingResponse?.ApprovalDetails?.DocumentId.toString());
        const urls = DownloadDocument + encodedDocumentId;
    sbaAxios({
        url: urls,
        responseType: 'blob'
    }).then((response) => {
        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${nameWithoutExtension}.${documentExtension}`
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

    });
    }
}
      
   
    catch (e) {
      SBNotify({
        type: "error",
        Msg: `Unable to download`,
    });
        
    }
}
}
function getFilenameWithoutExtension(filename) {
  return filename.split('.').slice(0, -1).join('.');
}
  return <>
  <div className='container-fluid' id='billing-Generate-Section'>
      <div className='row mt-2 justify-content-between'>
              <div className='col-12 col-lg-3'>
          <div>
          <label className='label'>Billing Date</label>
          <div>
              <SBDatePicker 
                  value={moment(billingDate)} 
                  onChange={(newDate)=>{setBillingDate(newDate); handleEndDate(newDate)}}
                  sx={{width:'100%'}}
              />
          </div>
         
        </div>
       
      </div>
    
          <div className='col-12 col-lg-5 fw-medium d-flex'>
              <span className='mt-auto'>
                  {showtext && billingResponse?.ApprovalDetails?.ApprovalStatus + " on " + moment(billingResponse?.ApprovalDetails?.ApprovalStatusUpdatedDate).format('MM/DD/YYYY, h:mm:ss A') + " by " + billingResponse?.ApprovalDetails?.ApprovalStatusUpdatedBy}
              </span>
          </div>
          <div className='col-12 col-lg-4'>
      <div className='row justify-content-end'>
        <div style={{ display: 'flex', alignItems: 'end', width: '250px' }}>
          <div style={{ flex: 1 }}>
            <label className="label">Status</label>
            <div>
            <SBADropDown
             data={statusList}
              textField={"statusName"}
              valueField={"statusId"}
             value={selectedStatus}
              onChange={handleSelectedStatus}
              popupSettings={{ className: "modalDD" }}
            />
           
             </div>
          </div>
          <span>
                <i className='fa-solid fa-magnifying-glass m-2 mt-0 SBA_hand' onClick={() => { openPreview() }}> </i>
              </span>
              <span id="btnDelete"><i class="  fa fa-refresh" style={{ float: "right", marginLeft: '10px', marginTop: '-23px', color: "#337ab7 !important", cursor: "pointer" }} title='Refresh' onClick={deleteClientBillingApproval}></i></span>
              {isSaveshow &&

                <span id="btnInsert"><i class="fa fa-save" style={{ float: "right", marginLeft: '10px', marginTop: '-23px', color: "#337ab7 !important", cursor: "pointer" }} title='save' onClick={saveClientBillingApproval}></i></span>

              }
              <span>
                <i
                  class="fas fa-file-excel mx-2 m-2 mt-2 SBA_hand"
                  style={{ color: "#1D6F42" }}
                  onClick={() => { downloadexcel() }}

                ></i>

              </span>
              <>
                {showAccordian ? <button
                  type="submit"
                  className="p-sm-btn px-2 me-2"
                  onClick={handleShowAccordian}
                              >
                                  <i class="fa-solid fa-arrow-right"></i>
                              </button> : <button
                                  type="submit"
                                  className="p-sm-btn px-2 me-2"
                                  onClick={handleShowAccordian}
                              >
                                  <i class="fa-solid fa-arrow-left"></i>
                              </button>}
          </>
        </div>
      </div>
    </div>
    </div>
    <div className='row mt-4'>
      <div style={{width:'100%'}}>
        <GeneralAccordian billingResponse={billingResponse} clientBillingId={clientBillingId}></GeneralAccordian>
      </div>
    </div>
  </div>
      {/* Billing Delete Modal ----- */}
      <Modal show={showDeleteModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setshowDeleteModal(false);
          }}
        >
          <Modal.Title>
          Do you want to delete Billing Summary?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This has been {billingResponse?.ApprovalDetails?.ApprovalStatus}. Deleting will remove all data. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setshowDeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={deleteBillingapproval}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
  <ToastContainer></ToastContainer>
  </>
  
};
const AccordionSection=({endDate, render, clientBillingId,invoiceId,type, handleBillingResponse})=>{
  
  const [clientStatements, setClientStatements] = useState([]);
  const [billingSummaries, setBillingSummaries] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [managerTransactions, setManagerTransactions] = useState([]);
  const [billingDate, setBillingDate] = useState(endDate.format('MM-DD-YYYY'));

  const getDocuments = async() => {
    try{
      const response = await sbaAxios({
        url: getBillingDocs,
        params:{
          billingDate: billingDate,
          clientBillingId: clientBillingId
        }
      });
      const billingdocs=response?.summnaryDocuments.filter(item => item.DocumentId != null && item.DocumentId != 0 );
      const invoicedocs=response?.invoiceDocuments.filter(item => item.DocumentId != null && item.DocumentId != 0 );
      setClientStatements(response?.ClientStatementDocuments);
      setBillingSummaries(billingdocs);
      setInvoices(invoicedocs);
      setManagerTransactions(response?.TransactionDocuments);
      handleBillingResponse(response);
    }
    catch(e){
      setClientStatements(null);
      setBillingSummaries(null);
      setInvoices(null);
      setManagerTransactions(null);
      handleBillingResponse(null);
    }
  };

  const getInvoiceDetails = async() => {
    try{
      const response = await sbaAxios({
       
        url: `${getinvoiceData}${clientBillingId},${invoiceId},${billingDate}` ,
      });
      const billingdocs=response?.summnaryDocuments.filter(item => item.DocumentId != null && item.DocumentId != 0 );
      const invoicedocs=response?.invoiceDocuments.filter(item => item.DocumentId != null && item.DocumentId != 0 );
      setClientStatements(response.ClientStatementDocuments);
      setBillingSummaries(billingdocs);
      setInvoices(invoicedocs);
      setManagerTransactions(response.TransactionDocuments);
      handleBillingResponse(response);
    }
    catch(e){
      handleBillingResponse();
    }
  }
  useEffect(()=>{
    setBillingDate(endDate.format('MM-DD-YYYY'))
  })
  useEffect(()=>{
    if(type==="billing")
    {
    if (clientBillingId > 0) 
    {
      getDocuments();
    }
  }
  else
  {
    getInvoiceDetails();
  }
  },[billingDate, clientBillingId,type,render])


function getFilenameWithoutExtension(filename) {
  return filename.split('.').slice(0, -1).join('.');
}
const getFileExtension=(filename)=> {
  if (filename.includes('.')) {
      return filename.split('.').pop();
  } else {
      return ''; 
  }
}
  const download=async(DocumentId,DocumentName,documentExtension)=>
  {
   
      try {     
  
        
          const nameWithoutExtension = getFilenameWithoutExtension(DocumentName);
          const encodedDocumentId = btoa(DocumentId.toString());
          const urls = DownloadDocument + encodedDocumentId;
          sbaAxios({
               url: urls,
               responseType: 'blob'
           }).then((response) => {
              const blob = new Blob([response]);
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${nameWithoutExtension}.${documentExtension}` 
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
        
       });
      
  }
        
     
      catch (e) {
        SBNotify({
          type: "error",
          Msg: `Unable to download`,
      });
          
      }
 
  }
  const pdfCellRenderer = (params) => {
    return (
      <div className="actions-cell">
        <i className="far fa-file-pdf SBA_hand" style={{ color:"red", margin: "0 8px", cursor: "pointer" }} onClick={() => {download(params.data.DocumentId,params.data.DocumentName,".pdf")}}></i>
      </div>
    );
  };

  const xlsxCellRenderer = (params) => {
    return (
      <div className="actions-cell">
        <i className="far fa-file-excel SBA_hand" style={{ color:"green", margin: "0 8px", cursor: "pointer" }} onClick={() => {download(params.data.DocumentId,params.data.DocumentName,".xls")}}></i>
      </div>
    );
  };
  const iconCellRenderer = (params) => {
    const ext=getFileExtension(params.data.DocumentName);
    if(ext=="xlsx")
    {
      return (
        <div className="actions-cell">
          <i className="far fa-file-excel SBA_hand" style={{ color:"green", margin: "0 8px", cursor: "pointer" }} onClick={() => {download(params.data.DocumentId,params.data.DocumentName,".xls")}}></i>
        </div>
      );
    }
    else
    {
    return (
      <div className="actions-cell">
        <i className="far fa-file-pdf SBA_hand" style={{ color:"red", margin: "0 8px", cursor: "pointer" }} onClick={() => {download(params.data.DocumentId,params.data.DocumentName,".pdf")}}></i>
      </div>
    );
    }
  };
  const defaultColDef = {
    sortable: false,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
  const clientStatementColumnDefs = [
    {headerName: 'Name', field: 'DocumentName',minWidth:250},
    {
      headerName: 'Report',
      field: 'report',
      cellRenderer: iconCellRenderer,
      sortable: false,
      filter: false,
      maxWidth: 100
    }
  ];
  
  const billingSummaryColumnDefs = [
    {headerName: 'Name', field: 'DocumentName', minWidth: 250},
    {
      headerName: 'Report',
      field: 'report',
      cellRenderer: xlsxCellRenderer,
      sortable: false,
      filter: false,
      maxWidth: 100
    }
  ];

  const invoicesColumnDefs = [
    {headerName: 'Name', field: 'DocumentName', minWidth: 250},
    {
      headerName: 'Report',
      field: 'report',
      cellRenderer: pdfCellRenderer,
      sortable: false,
      filter: false,
      maxWidth: 100
    }
  ];

  const managerTransactionsColumnDefs = [
    {headerName: 'Name', field: 'DocumentName', minWidth: 350},
    {
      headerName: 'Date', 
      field: 'DocumentDate',
      valueFormatter: (params) => {
        // Use Moment.js to format the date as 'MM-DD-YYYY'
        if (params.value) {
          return moment(params.value).format('MM-DD-YYYY');
        }
        return ''; // Handle null or undefined values gracefully
      },
      minWidth:50,
    },
    {
      headerName: 'Report',
      field: 'report',
      cellRenderer: iconCellRenderer,
      sortable: false,
      filter: false,
      minWidth:100
    }
  ];

  return <>
  <Accordion defaultActiveKey={[0]}  >
            <Accordion.Item eventKey={0} >
                    <Accordion.Header>Client Statements</Accordion.Header>
                    <Accordion.Body>
                      <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                        <AgGridReact rowData={clientStatements} columnDefs={clientStatementColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                      </div>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey={1} >
                    <Accordion.Header>Billing Summary</Accordion.Header>
                    <Accordion.Body>
                      <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                        <AgGridReact rowData={billingSummaries} columnDefs={billingSummaryColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                      </div>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item  eventKey={2}>
                    <Accordion.Header>Invoices</Accordion.Header>
                    <Accordion.Body>
                      <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                        <AgGridReact rowData={invoices} columnDefs={invoicesColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                      </div>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item  eventKey={3}>
                    <Accordion.Header>Manager Transactions</Accordion.Header>
                    <Accordion.Body>
                      <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                        <AgGridReact rowData={managerTransactions} columnDefs={managerTransactionsColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                      </div>
                    </Accordion.Body>
                </Accordion.Item>
        </Accordion>
  </>
};

const GeneralAccordian = ({billingResponse,clientBillingId}) =>{
  const [totalRowData, setTotalRowData] = useState([]);
  const [grossFeeSummary, setGrossFeeSummary] = useState([]);
  const [grossFeeMonthly, setGrossFeeMonthly] = useState([]);
  const [grossFeeIMonthly, setGrossFeeIMonthly] = useState([]);
  const [creditFeeSummary, setCreditFeeSummary] = useState([]);
  const [creditFeeMonthly, setCreditFeeMonthly] = useState([]);
  const [creditFeeIMonthly, setCreditFeeIMonthly] = useState([]);
  const [ppliFeeSummary, setPpliFeeSummary] = useState([]);
  const [ppliFeeMonthly, setPpliFeeMonthly] = useState([]);
  const [ppliFeeIMonthly, setPpliFeeIMonthly] = useState([]);
  const [assetDetailsMonthly, setAssetDetailsMonthly] = useState([]);
  const [assetDetailsIMonthly, setAssetDetailsIMonthly] = useState([]);
 const [feeType,setFeeType]=useState(7);
  useEffect(()=>{
    if(billingResponse){
      setTotalRowData(billingResponse?.ApprovalDetails?.BillingQuarterTotal?.LstBillingTotalByBasket)
      setGrossFeeSummary(billingResponse?.ApprovalDetails?.BillingGrossFee?.LstBillingGrossFeeSummary)
      setGrossFeeMonthly(billingResponse?.ApprovalDetails?.BillingGrossFee?.LstBillingGrossFeeMonthly)
      setGrossFeeIMonthly(billingResponse?.ApprovalDetails?.BillingGrossFee?.LstBillingGrossFeeFlow)
      setCreditFeeSummary(billingResponse?.ApprovalDetails?.BillingCredits?.LstBillingCreditSummary)
      setCreditFeeMonthly(billingResponse?.ApprovalDetails?.BillingCredits?.LstBillingCreditMonthly)
      setPpliFeeSummary(billingResponse?.ApprovalDetails?.BillingPpliCredits?.LstBillingPpliCreditSummary)
      setPpliFeeMonthly(billingResponse?.ApprovalDetails?.BillingPpliCredits?.LstBillingPpliCreditMonthly)
      setAssetDetailsMonthly(billingResponse?.ApprovalDetails?.BillingAssets?.LstBillingAssetsMonthly)
      setAssetDetailsIMonthly(billingResponse?.ApprovalDetails?.BillingAssets?.LstBillingAssetsFlows)
     getFeeType(clientBillingId);
    }
   
  },[billingResponse]);

  const getFeeType = async (billingID) => {
    try {
      const dat = await sbaAxios({
        url: getClientBillingFee + `${billingID}`
      })
      setFeeType(dat[0].FeeSubTypeId);
      return dat;
      
    }
    catch (e) {
      return [];
    }
  }
  
  // Utility function to format date as MM-DD-YYYY
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  // Utility function to round numbers to 2 decimal places
  const formatNumber = (number) => {
    return Number(number).toFixed(2);
  };
  
  const totalColumnDefs = [
      { headerName: "Date", field: "BillingDate", valueFormatter: (params) => formatDate(params.value)},
    {headerName: "Portfolio", field:"PortfolioName"},
    {headerName: "Starting AUM", field:"StartingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Gross", field: "Gross", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Flows", field: "FlowAmount", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Flow Fees", field: "FlowFee", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Adjusted AUM", field: "AdjustedAUM", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Adjusted Gross", field: "AdjustedGross", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Credit", field: "Credits", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "PPLI Credit", field: "PpliCredits", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Net", field:"NetValue", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Fees", field: "ManagementFee", valueFormatter:(params) =>
    // feeType==7?
    getPercentageFormat(params.value,7)
    // :CurrencyFormat(params.value,2) 
    ,cellStyle: { textAlign: "right" }}
  ];

  const grossSummaryColumnDefs = [
    {headerName: "Date", field: "MonthDate", valueFormatter:(params) => formatDate(params.value)},
    {headerName: "Starting AUM", field: "MonthStartingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Flows", field: "MonthFlows", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Total AUM", field: "MonthEndingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Total Fee", field: "MonthGrossFee", valueFormatter:(params) =>  CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }}
  ];

  const grossMonthlyColumnDefs = [
    {headerName: "Fee Definition", field: "FeeDefinition"},
    {headerName: "Applicable AUM", field: "ApplicableAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Yearly Fee", field: "YearlyFee", valueFormatter:(params) => feeType==7?getPercentageFormat(params.value,2):CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Monthly Fee", field: "MonthlyFee", valueFormatter:(params) =>feeType==7?getPercentageFormat(params.value,2):CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Calculated Fee", field: "CalculatedFee", valueFormatter:(params) => feeType==7?getPercentageFormat(params.value,2):CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }}
  ];

  const grossIMonthlyColumnDefs = [
    {headerName: "Flow Date", field: "FlowDate", valueFormatter:(params) => formatDate(params.value)},
    {headerName: "Fee Definition", field: "FeeDefinition"},
    {headerName: "Flow Amount", field: "FlowAmount",valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Yearly Fee", field: "YearlyFee",valueFormatter:(params) => feeType==7?getPercentageFormat(params.value,2):CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Monthly Fee", field: "MonthlyFee",valueFormatter:(params) =>feeType==7?getPercentageFormat(params.value,2):CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Daily Fee Ratio", field: "DailyFeeRatio",valueFormatter:(params) => getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Calculated Fee", field: "CalculatedFee",valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }}
  ];

  const creditSummaryColumnDefs = [
    {headerName: "Portfolio", field: "PortfolioName"},
    {headerName: "Asset", field: "AssetName"},
    {headerName: "Starting AUM", field: "QuarterStartingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Flows", field: "QuarterFlows", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Total AUM", field: "QuarterEndingAUM", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Quarterly Fee", field: "YearlyFee", valueFormatter:(params) => getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Total Fee", field: "YearlyFee", valueFormatter:(params) => getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }}
  ];

  const creditMonthlyColumnDefs = [
    {headerName: "Date", field: "MonthDate", valueFormatter:(params) => formatDate(params.value)},
    {headerName: "Starting AUM", field: "MonthStartingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Yearly Fee", field: "YearlyFee", valueFormatter:(params) =>getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Monthly Fee", field: "MonthlyFee", valueFormatter:(params) => getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Calculated Fee", field: "MonthlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  ];

  const creditIMonthlyColumnDefs = [
    {headerName: "Portfolio", field: "Portfolio"},
    {headerName: "Asset", field: "asset"},
    {headerName: "Flow Date", field: "FlowDate",valueFormatter:(params) => formatDate(params.value)},
    {headerName: "Flow Amount", field: "FlowAmount", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Yearly Fee", field: "YearlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Monthly Fee", field: " MonthlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Daily Fee Ratio", field: "DailyFeeRatio", valueFormatter:(params) => getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Calculated Fee", field: "CalculatedFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  ];

  const ppliSummaryColumnDefs = [
    {headerName: "Portfolio", field: "Portfolio"},
    {headerName: "Asset", field: "asset"},
    {headerName: "Starting AUM", field: "StartingAUM", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Flows", field: "Flows", valueFormatter:(params) =>  CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Total AUM", field: "TotalAUM", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Total Fee", field: "TotalFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }}
  ];

  const ppliMonthlyColumnDefs = [
    {headerName: "Date", field: "Date", valueFormatter:(params) => formatDate(params.value)},
    {headerName: "Starting AUM", field: "StartingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Yearly Fee", field: "YearlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Monthly Fee", field: "MonthlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Calculated Fee", field: "CalculatedFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  ];

  const ppliIMonthlyColumnDefs = [
    {headerName: "Portfolio", field: "Portfolio"},
    {headerName: "Asset", field: "asset"},
    {headerName: "Flow Date", field: "FlowDate",valueFormatter:(params) => formatDate(params.value)} ,
    {headerName: "Flow Amount", field: "FlowAmount", valueFormatter:(params) =>CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Yearly Fee", field: "YearlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Monthly Fee", field: " MonthlyFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Daily Fee Ratio", field: "DailyFeeRatio", valueFormatter:(params) => getPercentageFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Calculated Fee", field: "CalculatedFee", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  ];

  const assetDetailsMonthlyColumnDefs = [
    {headerName: "Portfolio", field: "PortfolioName"},
    {headerName: "Asset", field: "AssetName"},
    {headerName: "Starting AUM", field: "StartingAUM", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
    {headerName: "Flows", field: "FirstMonthFlows", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  {headerName: "Flows", field: "SecondMonthFlows", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  {headerName: "Flows", field: "ThirdMonthFlows", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},  
];

  const assetDetailsIMonthlyColumnDefs = [
    {headerName: "Portfolio", field: "PortfolioName"},
    {headerName: "Asset", field: "AssetName"},
    {headerName: "Flow Date", field: "FlowDate",valueFormatter:(params) => formatDate(params.value)},
    {headerName: "Flow Amount", field: "FlowAmount", valueFormatter:(params) => CurrencyFormat(params.value,2),cellStyle: { textAlign: "right" }},
  ];
  // Formatting the number using thousand separators
const ThousandsSeparators = (num) => {
  if (num != undefined) {
      let num_parts = num.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
  }
  else{
    return 0;
  }
}
const gridOptions = {
  grandTotalRow: "bottom",
}
const defaultColDef = {
  sortable: false,
  filter: false,
  suppressMovable: true,
  flex: 1,
  resizable:true
};
  return(
    <>
    <Accordion defaultActiveKey={['0']} alwaysOpen>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Total</Accordion.Header>
        <Accordion.Body>
          <div className="form-group">
            <div className="clearfix"></div>
            <br />
            <label className="col-sm-3 fw-medium">Gross Fees</label>
            <label className="col-sm-3 fw-medium" style={{ textAlign:'right'}}>{'$'+ThousandsSeparators(billingResponse?.ApprovalDetails?.BillingQuarterTotal.Gross.toFixed(2))}</label>
            <div className="clearfix"></div>
            <br />
            <label className="col-sm-3 fw-medium">Credits</label>
            <label className="col-sm-3 fw-medium" style={{ textAlign:'right'}}>{CurrencyFormat(Math.abs(Number(billingResponse?.ApprovalDetails?.BillingQuarterTotal.Credits || 0,2)))}</label>
            <div className="clearfix"></div>
            <br />
            <label className="col-sm-3 fw-medium">PPLI Credits</label>
            <label className="col-sm-3 fw-medium" style={{ textAlign:'right'}}>{'$'+ThousandsSeparators(billingResponse?.ApprovalDetails?.BillingQuarterTotal.PpliCredits.toFixed(2))}</label>
            <div className="clearfix"></div>
            <br />
            <label className="col-sm-3 fw-medium">Net Fees</label>
            <label className="col-sm-3 fw-medium" style={{textAlign:'right'}}>{'$'+ThousandsSeparators(billingResponse?.ApprovalDetails?.BillingQuarterTotal.NetValue.toFixed(2))}</label>
            <div className="clearfix"></div>
            <br />
          </div>
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      <Accordion>
      <Accordion.Item eventKey='1'>
        <Accordion.Header>Total Fees by Account</Accordion.Header>
        <Accordion.Body>
          <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
            <AgGridReact rowData={totalRowData} columnDefs={totalColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey='2'>
        <Accordion.Header>Gross Fee</Accordion.Header>
        <Accordion.Body>
          <div>
            <Accordion>
              <Accordion.Item eventKey='0'>
                <Accordion.Header>Summary</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={grossFeeSummary} columnDefs={grossSummaryColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='1'>
                <Accordion.Header>Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={grossFeeMonthly} columnDefs={grossMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='2'>
                <Accordion.Header>Intra-Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={grossFeeIMonthly} columnDefs={grossIMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      {/* <Accordion.Item eventKey='3'>
        <Accordion.Header>Credit</Accordion.Header>
        <Accordion.Body>
          <div>
            <Accordion>
              <Accordion.Item eventKey='0'>
                <Accordion.Header>Summary</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={creditFeeSummary} columnDefs={creditSummaryColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='1'>
                <Accordion.Header>Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={creditFeeMonthly} columnDefs={creditMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='2'>
                <Accordion.Header>Intra-Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={creditFeeIMonthly} columnDefs={creditIMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Accordion.Body>
      </Accordion.Item> */}
      {/* <Accordion.Item eventKey='4'>
        <Accordion.Header>PPLI</Accordion.Header>
        <Accordion.Body>
          <div>
            <Accordion>
              <Accordion.Item eventKey='0'>
                <Accordion.Header>Summary</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={ppliFeeSummary} columnDefs={ppliSummaryColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='1'>
                <Accordion.Header>Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={ppliFeeMonthly} columnDefs={ppliMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='2'>
                <Accordion.Header>Intra-Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={ppliFeeIMonthly} columnDefs={ppliIMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Accordion.Body>
      </Accordion.Item> */}
      <Accordion.Item eventKey='5'>
        <Accordion.Header>Asset Details</Accordion.Header>
        <Accordion.Body>
          <div>
            <Accordion>
              <Accordion.Item eventKey='0'>
                <Accordion.Header>Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={assetDetailsMonthly} columnDefs={assetDetailsMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey='1'>
                <Accordion.Header>Intra-Monthly</Accordion.Header>
                <Accordion.Body>
                <div className="ag-theme-alpine" style={{ height: "50vh", width: "100%" }}>
                  <AgGridReact rowData={assetDetailsIMonthly} columnDefs={assetDetailsIMonthlyColumnDefs} defaultColDef={defaultColDef}></AgGridReact>
                </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    </>
  );
};

const InvoiceBillSection = ({setRender,billingDatee, invoiceId,contactId,handleShowAccordian, showAccordian, handleEndDate, billingResponse}) => {
  const [statusList,setstatusList] =useState([
    {statusId: 1, statusName:"Generated"},
    {statusId: 2, statusName:"Approved"},
  ])
  const [invoiceDate, setInvoiceDate] = useState(billingDatee);
    const [selectedStatus, setSelectedStatus] = useState(statusList[0]);
  const [billingApprovalId,setbillingApprovalId]=useState(0);
  const[showDeleteModal,setshowDeleteModal]=useState(false);
  const [showtext,setShowText]=useState(false);
  const[invoiceAdjumentdt,setInvoiceAdjustmentdt]=useState([]);
  const [selectedinvoiceadjustment,setselectedInvoiceadjustment]=useState();
  const quartersec=billingResponse?.InvoiceData?.DetailsDTO?.LstMonthlyDetailsDTO;
  const [monthlydt,setMonthlyDt]=useState();
  const [assetaumdt,setAssetaumdt]=useState();
const [creditamount,setcreditamount]=useState();
const[ppliamount,setppliamount]=useState();
const[invcadjustmentamount,setinvcadjustmentamount]=useState([]);
const[showRefreshModal,setshowRefreshModal]=useState(false);
const [isSaveshow,setisSaveshow]=useState(false);
const [statusmsg,setstatusmsg]=useState();
  let totalFees = 0.0;
  let flowMonthRow = 1;
const totalAmountDue = totalFees + billingResponse?.InvoiceData?.DetailsDTO?.SbaCredit + billingResponse?.InvoiceData?.DetailsDTO?.PpliCredit;
const adjustmentLabel = totalAmountDue < 0 ? "Amount to be returned " : "Amount due for ";
const assetaum=billingResponse?.InvoiceData?.DetailsDTO?.LstMonthlyDetailsDTO[0];
const Months = ["January", "February",
"March", "April", "May",
"June", "July", "August",
"September", "October",
"November", "December"
];
const [advisoryfeetotal,setAdvisoryfeeTotal]=useState();
const[totalamountdue,setTotalAmountdue]=useState();
const[grandtotalamountdue,setGrandAmountdue]=useState();
  useEffect(() => {
    setMonthlyDt(
      quartersec?.map((item, index) => ({
        ...item,
        RowIndex: index,
      }))
    );
    setAssetaumdt({"Aumamt": assetaum?.AumAmount,"AumFee":assetaum?.AumFee});
    getInvoiceAdjustmentText();
    setAdvisoryfeeTotal(billingResponse?.InvoiceData?.DetailsDTO?.AdvisoryFee);
    setTotalAmountdue(billingResponse?.InvoiceData?.DetailsDTO?.TotalAdvisoryFee);
    setGrandAmountdue(billingResponse?.InvoiceData?.DetailsDTO?.TotalNetFee);
    setcreditamount(billingResponse?.InvoiceData?.DetailsDTO?.SbaCredit);
    setppliamount(billingResponse?.InvoiceData?.DetailsDTO?.PpliCredit);
    setinvcadjustmentamount(billingResponse?.InvoiceData?.DetailsDTO?.AdjustmentAmount);
}, [quartersec,assetaum]);

useEffect(() => {
  if (billingResponse?.InvoiceData?.InvoiceApprovalId >0) {
   
    setselectedInvoiceadjustment( {"InvoiceAdjustmentId": billingResponse?.InvoiceData?.DetailsDTO?.InvoiceAdjustmentId,
    "InvoiceAdjustmentText": billingResponse?.InvoiceData?.DetailsDTO?.InvoiceAdjustmentText}
   );
  }
  else
  {
    
   
  }
  
  loadInvcStatus();
  CreateStatusMessage();
 
}, [billingResponse]);
  const handleSelectedStatus = (e) => {
    setSelectedStatus(e.value);
    setRender(val=>!val)
  }

  const loadInvcStatus =  ()=> {
if(billingResponse?.InvoiceData?.InvoiceApprovalId>0)
{
    if (billingResponse?.InvoiceData?.InvoiceStatusName=="Approved") 
    {
       
      setstatusList([
       
        {statusId: 2, statusName:"Approved"},
      ])
        setSelectedStatus( {statusId: 2, statusName:"Approved"});
        setisSaveshow(false);
    }
    else {
     const dt=statusList?.filter(item=>item.statusId===1)
        if (dt.length == 0) {
          setstatusList(
            {statusId: 1, statusName:"Generated"},
           
          )
            
        }
      
        else

        {
          setstatusList([
            {statusId: 1, statusName:"Generated"},
            {statusId: 2, statusName:"Approved"},
          ]);
        }
        setisSaveshow(true);
    }
  }
  else
  {
    setstatusList([
      {statusId: 1, statusName:"Generated"},
      {statusId: 2, statusName:"Approved"},
    ]);
    setisSaveshow(true);
  }
}

const CreateStatusMessage = function () {
  var msg = "";
  var status = ["", "Generated", "Approved", "Delete Approved"];
 
  if (billingResponse?.InvoiceData?.InvoiceApprovalId > 0) {
      msg=status[billingResponse?.InvoiceData?.InvoiceStatusId] + " on " + moment(billingResponse?.InvoiceData?.ModifiedDate).format('MM/DD/YYYY, h:mm:ss A') + " by " + billingResponse?.InvoiceData?.ModifiedBy;
      setstatusmsg(msg);
      setShowText(true);
  }
  else
  setShowText(false);
}
 const saveInvoiceApproval=async(type)=>
 {
 
  if(billingResponse?.InvoiceData?.InvoiceApprovalId ==0)
  InsertInvoiceApproval(type);
  else
  await UpdateInvoiceApproval(type);
  setRender(value=>!value);
 }

 const InsertInvoiceApproval=(type)=>
 {
  var date = invoiceDate;
  var month = new Date(date).getMonth() + 1;
  var quarter = 0;

    if (month == 1 || month == 2 || month == 3)
      quarter = 1;
    else if (month == 4 || month == 5 || month == 6)
      quarter = 2;
    else if (month == 7 || month == 8 || month == 9)
      quarter = 3;
    else if (month == 10 || month == 11 || month == 12)
      quarter = 4;
      const datdt = [];
      datdt.push({
        InvoiceApprovalId: 0,
        IsStartingAum: assetaum.IsStartingAum,
        AumDate: assetaum.AumDate === "0001-01-01T00:00:00" ? new Date() : assetaum.AumDate,
        AumMonth: assetaum.AumMonth,
        AumYear: assetaum.AumYear,
        AumAmount: assetaumdt.Aumamt,
        AumFee: assetaumdt.AumFee,
        ModifiedByUserId: 0
      });
      const monthlyData = monthlydt.map(item => ({
        InvoiceApprovalId: 0,
        IsStartingAum: item.IsStartingAum,
        AumDate: item.AumDate === "0001-01-01T00:00:00" ? new Date() : item.AumDate,
        AumMonth: item.AumMonth,
        AumYear: item.AumYear,
        AumAmount: item.AumAmount,
        AumFee: item.AumFee,
        ModifiedByUserId: 0
      }));
      
      datdt.push(...monthlyData);
      
      
      const data={
        "InvoiceId": invoiceId ,
          "BillingApprovalId": billingResponse?.InvoiceData?.BillingApprovalId,
          "QuarterNum": billingResponse?.InvoiceData?.QuarterNum,
          "YearNum": billingResponse?.InvoiceData?.YearNum ,
          "InvoiceStatusId": type=="delete"?3:selectedStatus.statusId, 
         
       "DetailsDTO": {
    
              "LstMonthlyDetailsDTO":datdt,
              "AdvisoryFee":advisoryfeetotal ,
              "SbaCredit": creditamount,
              "PpliCredit": ppliamount,
              "InvoiceAdjustmentId": selectedinvoiceadjustment.InvoiceAdjustmentId,
              "AdjustmentAmount": invcadjustmentamount,
              "TotalAdvisoryFee": totalamountdue,
              "TotalNetFee": grandtotalamountdue,
          }
        }

    sbaAxios({
      url: `${insertInvoiceApproval}`,
      method: "post",
      data: data,
    })
      .then(async (response) => {
        if (response) {
          SBNotify({
            type: "success",
            Msg: "Invoice saved Successfully",
          });
          if(type=="delete")
          {
          setstatusList([
            {statusId: 2, statusName:"Approved"},
            {statusId: 1, statusName:"Generated"},
           
          ]);
          setSelectedStatus([]);
          setshowRefreshModal(false)
         
        }
        
        if(billingResponse?.InvoiceData?.DocumentId===0)
        SaveInvoiceDocument(response);
        setRender(value => !value);
        } else {
          SBNotify({
            type: "error",
            Msg: `Failed to Insert`,
          });
        }
      })
      .catch(() => { });
  }

  const UpdateInvoiceApproval=(type)=>
  {
   var date = invoiceDate;
   var month = new Date(date).getMonth() + 1;
   var quarter = 0;
 
     if (month == 1 || month == 2 || month == 3)
       quarter = 1;
     else if (month == 4 || month == 5 || month == 6)
       quarter = 2;
     else if (month == 7 || month == 8 || month == 9)
       quarter = 3;
     else if (month == 10 || month == 11 || month == 12)
       quarter = 4;
     const datdt=  monthlydt.map(item => ({ 
         "InvoiceApprovalId": item.InvoiceApprovalId ,
          "InvoiceApprovalDetailId": item.InvoiceApprovalDetailId,
         "IsStartingAum": item.IsStartingAum,
         "AumDate": item.AumDate==="0001-01-01T00:00:00"?new Date():item.AumDate,
         "AumMonth": item.AumMonth,
         "AumYear": item.AumYear ,
         "AumAmount": item.AumAmount ,
         "AumFee": item.AumFee,
         "ModifiedByUserId": 0
       }));
       datdt.push({ 
         "InvoiceApprovalId": assetaum.InvoiceApprovalId ,
         "InvoiceApprovalDetailId": assetaum.InvoiceApprovalDetailId,
       "IsStartingAum":  assetaum.IsStartingAum,
       "AumDate": assetaum.AumDate==="0001-01-01T00:00:00"?new Date():assetaum.AumDate,
       "AumMonth": assetaum.AumMonth,
       "AumYear": assetaum.AumYear ,
       "AumAmount": assetaumdt.Aumamt ,
       "AumFee": assetaumdt.AumFee,
       "ModifiedByUserId": 0});
       const data={
         "InvoiceId": invoiceId ,
         "InvoiceApprovalId":billingResponse?.InvoiceData?.InvoiceApprovalId,
           "BillingApprovalId": billingResponse?.InvoiceData?.BillingApprovalId,
           "QuarterNum": billingResponse?.InvoiceData?.QuarterNum,
           "YearNum": billingResponse?.InvoiceData?.YearNum ,
           "InvoiceStatusId": type=="delete"?3:selectedStatus.statusId, 
          
        "DetailsDTO": {
     
               "LstMonthlyDetailsDTO":datdt,
               "AdvisoryFee":advisoryfeetotal ,
               "SbaCredit": creditamount,
               "PpliCredit": ppliamount,
               "InvoiceAdjustmentId": selectedinvoiceadjustment.InvoiceAdjustmentId,
               "AdjustmentAmount": invcadjustmentamount,
               "TotalAdvisoryFee": totalamountdue,
               "TotalNetFee": grandtotalamountdue,
           }
         }
 
     sbaAxios({
       url: `${updateInvoiceApproval}`,
       method: "post",
       data: data,
     })
       .then(async (response) => {
         if (response) {
           SBNotify({
             type: "success",
             Msg: "Invoice Updated Successfully",
           });
           setshowRefreshModal(false);
           setRender(value => !value);
           if(selectedStatus.statusId==2)
           await updateDocumentStatus(12,billingResponse?.InvoiceData?.DocumentId,0)
         } else {
           SBNotify({
             type: "error",
             Msg: `Failed to Update`,
           });
         }
       })
       .catch(() => { });
   }
 
const SaveInvoiceDocument=(invoiceapprvId)=>
{
  const activityXRefs=[];
   activityXRefs.push(
    {
        activityXRefId: 0,
        activityId: 0,
        activityEntityTypeId:0,
        activityEntityType: "Contact",
        entityId: contactId,
        entityName:"",
    })
  const data = {
    "activitySummary": {
        "activityId": 0,
        "activitySourceId": 2,
        "activityTypeId": 2,
        "activitySubTypeId": 4,
          "activityName": billingResponse?.InvoiceData?.InvoiceName,
        "activityDescription":  null,
        "activityDescriptionHtml":  null,
        "activityDate": invoiceDate,
        "documentStatusId": 0
    },
    "activityDetails":
    {

        "activityDetailId": 0,
        "activityId": 0,
        "emailMessageId": "",
        "emailFrom": "",
        "emailTo": "",
        "mailCc": "",
        "emailSubject": "",
        "emailBody": "",
        "emailBodyHtml": "",
        "emailDate": invoiceDate,
        "meetingDate": invoiceDate,
    },
    "activityXRefs": activityXRefs,
    "modifiedBy": 0
  }
    
    sbaAxios({
      url: `${insertOrUpdateActivityDetails}`,
      method: "post",
      data: data,
  })
  .then((response) => {
    if (response > 0) {
       sbaAxios({
        url:saveinvoicepdfdoc,
        params:{
          ActivityId: response,
          InvoiceId: invoiceId,
          InvoiceDate: moment(invoiceDate).format("MM-DD-yyyy") 
        },
        method:'GET',
      })
      .then((repos) => {  
        if(billingResponse?.InvoiceData?.DocumentId==0)
        {
          updateinvoiceDocument(invoiceapprvId,repos);
          if(selectedStatus.statusId==2)
          updateDocumentStatus(12,repos,0);
          else
          updateDocumentStatus(60,repos,0);
        }
       
      })
      setRender(value => !value);
    }
    })
    .catch((error) => {
        console.error(error);
    });
};
const updateDocumentStatus=(statusId,docId,billingApprovalid)=>
{
 

 sbaAxios({ url: `${updateBillingdocstatus}${billingApprovalid},${docId},{0},${statusId}`
  , method: 'get' })
 .then((repos) => {  
 })
 .catch((error) => {
   SBNotify({
     type: "error",
     Msg: `failed to update document status`,
 });
 });
}

const updateinvoiceDocument=(invoiceApprovalId,docId)=>
{
 

 sbaAxios({ url: `${updateInvoiceDocument}${invoiceApprovalId},${docId}`
  , method: 'get' })
 .then((repos) => {  
  setRender(val=>!val);
 })
 .catch((error) => {
  
 });
}
const getInvoiceAdjustmentText= async ()=>
{
  try{
    const response = await sbaAxios({
      url: `${getbillingInvoiceadjustment}`,
    });
    setInvoiceAdjustmentdt(response);
    if (billingResponse?.InvoiceData?.InvoiceApprovalId===0)
    setselectedInvoiceadjustment(response[0]);
  }
  catch(e){

  }
}
const GetPrevInvQuarterEndDate =  ()=> {
  var invDate = new Date(invoiceDate),
      quarter = Math.floor((invDate.getMonth() / 3)),
      startDate,
      endDate;
  startDate = new Date(invDate.getFullYear(), quarter * 3 - 3, 1);
  endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
  const edate=moment(endDate).format("MMMM-DD-yyyy")
  return edate;
}

const GetYearForInvoiceDate =  ()=> {
    var invDate = new Date(invoiceDate);
    return invDate.getFullYear();
}
const GetInvoiceDateQuarterText =  ()=> {
  const quarters = ["1st", "2nd", "3rd", "4th"];
  var invDate = new Date(invoiceDate);
  var quarterNbr = Math.floor((invDate.getMonth() + 3) / 3);
  return quarters[quarterNbr - 1];
}

const calcAumamtTotal=(e,id)=>
{
 const val=e.replace(/[^0-9.\-]/g, '');
  const filtereddata= monthlydt.filter(item=>!item.IsStartingAum);
  const dt = filtereddata.map(item => {
    if (item.RowIndex === id) {
      return {
        ...item,
        AumAmount: parseFloat(val||0), 
      };
    }
    return item; 
  });
  setMonthlyDt(dt);
}
const calcAumTotal=(e,id)=>
{
  const val=e.replace(/[^0-9.\-]/g, '');
 const filtereddata= monthlydt.filter(item=>!item.IsStartingAum);
  const dt = filtereddata.map(item => {
    if (item.RowIndex === id) {
      return {
        ...item,
        AumFee: parseFloat(val||0), 
      };
    }
    return item; 
  });
  setMonthlyDt(dt);
  const totfee = dt.reduce((total, item) => total + parseFloat((item.AumFee) || 0), 0);

  const feetotal=parseFloat(assetaumdt.AumFee)+parseFloat(totfee);
  
  const tot=parseFloat(creditamount)+parseFloat(ppliamount);
  const totaldueamt=parseFloat(feetotal)+parseFloat(tot);
  const grandtotal=parseFloat(totaldueamt)+parseFloat(invcadjustmentamount);
  setAdvisoryfeeTotal(feetotal);
  setTotalAmountdue(totaldueamt);
  setGrandAmountdue(grandtotal)
}
const calcadvisory=(e)=>
{
  const val=e.replace(/[^0-9.\-]/g, '');
  const filtereddata= monthlydt.filter(item=>!item.IsStartingAum);
  const totfee = filtereddata.reduce((total, item) => total + parseFloat(item.AumFee || 0), 0);

setAssetaumdt({"Aumamt":assetaumdt.Aumamt,"AumFee":parseFloat(val||0)});
  const feetotal=parseFloat(val||0)+parseFloat(totfee);
  const tot=parseFloat(creditamount)+parseFloat(ppliamount);
  const totaldueamt=parseFloat(feetotal)+parseFloat(tot);
  const grandtotal=parseFloat(totaldueamt)+parseFloat(invcadjustmentamount);
  setAdvisoryfeeTotal(feetotal);
  setTotalAmountdue(totaldueamt);
  setGrandAmountdue(grandtotal)
}
const calcadvisoryamt=(e)=>
{
  const val=e.replace(/[^0-9.\-]/g, '');;
  setAssetaumdt({"Aumamt":  parseFloat(val) || 0,"AumFee": assetaumdt.AumFee});
}
const calccredit=(e)=>
{
  const val=e.replace(/[^0-9.\-]/g, '');;
  const filtereddata= monthlydt.filter(item=>!item.IsStartingAum);
  const totfee = filtereddata.reduce((total, item) => total + parseFloat(item.AumFee || 0), 0);
  const feetotal=parseFloat(assetaumdt.AumFee)+parseFloat(totfee);
  const total=parseFloat(val ||0)+parseFloat(ppliamount);
  const totaldueamt=parseFloat(feetotal)+parseFloat(total);
  const grandtotal=parseFloat(totaldueamt)+parseFloat(invcadjustmentamount);
  setAdvisoryfeeTotal(feetotal);
  setTotalAmountdue(totaldueamt);
  setGrandAmountdue(grandtotal);
  setcreditamount(val);
}
const calcppli=(e)=>
{
  const val=e.replace(/[^0-9.\-]/g, '');
  const filtereddata= monthlydt.filter(item=>!item.IsStartingAum);
  const totfee = filtereddata.reduce((total, item) => total + parseFloat(item.AumFee || 0), 0);
  const feetotal=parseFloat(assetaumdt.AumFee)+parseFloat(totfee);
  const total=parseFloat(creditamount)+parseFloat(val||0);
  const totaldueamt=parseFloat(feetotal)+parseFloat(total);
  const grandtotal=parseFloat(totaldueamt)+parseFloat(invcadjustmentamount);

 
  setAdvisoryfeeTotal(advisoryfeetotal);
  setTotalAmountdue(totaldueamt);
  setGrandAmountdue(grandtotal);
  setppliamount(val);
}
const calcAdjustmentAmount=(e)=>
{
   const val=e.replace(/[^0-9.\-]/g, '');
  const filtereddata= monthlydt.filter(item=>!item.IsStartingAum);
  const totfee = filtereddata.reduce((total, item) => total + parseFloat(item.AumFee || 0), 0);
  const feetotal=parseFloat(assetaumdt.AumFee)+parseFloat(totfee);
  const total=parseFloat(creditamount) + parseFloat(ppliamount);
  const totaldueamt=parseFloat(feetotal)+parseFloat(total);
  const grandtotal=parseFloat(totaldueamt) + parseFloat(val||0) ;

 
  setAdvisoryfeeTotal(advisoryfeetotal);
  setTotalAmountdue(totaldueamt);
  setGrandAmountdue(grandtotal);
  setinvcadjustmentamount(parseFloat(val)||0)
}
const invoiceadjustmentchange=(e)=>
{
  
  setselectedInvoiceadjustment(e.value);
}

const downloadpdf=async()=>
{
  if (invoiceId === 0) {
    SBNotify({
      type: "error",
      Msg: `Please Select the Billing Invoice`,
  });
   
}
else {
    try {     
if(billingResponse?.InvoiceData?.DocumentId==0)
{
  const documentName = "InvoiceGeneration" + " - " + GetInvoiceDateQuarterText() + " Quarter Invoice " + new Date(invoiceDate).getFullYear() + ".pdf";
        await sbaAxios({
            url: getpdfinvoiceReport,
            params: {
              InvoiceId: invoiceId,
              InvoiceDate: invoiceDate,
            },
            method: 'GET',
            responseType: 'blob'
        }).then((response) => {
            const blobUrl = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = documentName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Revoke the blob URL to free up memory
            window.URL.revokeObjectURL(blobUrl);

        })
      }
      else{
        const documentExtension = ".pdf";
        const nameWithoutExtension = getFilenameWithoutExtension(billingResponse?.InvoiceData?.DocumentName);
        const encodedDocumentId = btoa(billingResponse?.InvoiceData?.DocumentId.toString());
        const urls = DownloadDocument + encodedDocumentId;
        sbaAxios({
             url: urls,
             responseType: 'blob'
         }).then((response) => {
            const blob = new Blob([response]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${nameWithoutExtension}.${documentExtension}` 
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
      
     });
    }
}
      
   
    catch (e) {
      SBNotify({
        type: "error",
        Msg: `Unable to download`,
    });
        
    }
}
}
function getFilenameWithoutExtension(filename) {
  return filename.split('.').slice(0, -1).join('.');
}

 return <>
  <div className='container-fluid'>
      <div className='row mt-2 justify-content-between'>
        {showtext &&
          <div className='col-md-12 text-end'>
           <p class="fw-medium mb-0"> {statusmsg}</p>
          </div>
        }
        <div className='col-md-3'>
          <div>
            <label className='label'>Invoice Date</label>
            <div style={{ width: '300px' }}>
              <SBDatePicker
                value={moment(invoiceDate)}
                onChange={(newDate) => { setInvoiceDate(newDate); handleEndDate(newDate) }}
                sx={{ width: '50%' }}
              />
            </div>

          </div>

        </div>
        <div className='col-md-3'>
          <label className='label'>Invoice Name:</label>
          <div>{billingResponse?.InvoiceData?.InvoiceName}</div>
        </div>
        <div className='col-md-6'>
          <div className='row justify-content-end'>
            <div style={{ display: 'flex', alignItems: 'end', width: '250px' }}>
              <div style={{ flex: 1 }}>
                <label className="label">Status</label>
                <div>
                  <SBADropDown
                    data={statusList}
                    textField={"statusName"}
                    valueField={"statusId"}
                   value={selectedStatus}
                    onChange={handleSelectedStatus}
                    popupSettings={{ className: "modalDD" }}
                  />

                </div>
              </div>

             
              {isSaveshow &&
              <span id="btnInsert"><i class="fa fa-save" style={{ float: "right", marginLeft: '10px', marginTop: '-23px', color: "#337ab7 !important", cursor: "pointer" }} title='save'   onClick={()=>{saveInvoiceApproval("save")}}></i></span>
              }
              <span id="btnDelete"><i class="  fa fa-refresh" style={{ float: "right", marginLeft: '10px', marginTop: '-23px', color: "#337ab7 !important", cursor: "pointer" }} title='Refresh' onClick={()=>{setshowRefreshModal(true)}}></i></span>
              <span >
              
              <i
                                                                            class="fas fa-file-pdf mx-2 m-2 mt-2 SBA_hand"
                                                                            style={{ color: "#F40F02" }}
                                                                            onClick={downloadpdf}
                                                                       ></i>
           
             
             </span>

            </div>
          </div>
        </div>
      </div>
      {billingResponse ?
      <div class="row detail  m-2 gap-2">
        <div class="row">
          <div className='col-md-2 mx-2'>
          <p class="fw-medium">  {billingResponse?.InvoiceData?.RecipientDTO?.RecipientName}
            {billingResponse?.InvoiceData?.RecipientDTO?.InvoiceAddress}
            {billingResponse?.InvoiceData?.RecipientDTO?.InvoiceAddressTwo}
            {billingResponse?.InvoiceData?.RecipientDTO?.InvoiceCity}
            {billingResponse?.InvoiceData?.RecipientDTO?.InvoiceState}
            {billingResponse?.InvoiceData?.RecipientDTO?.InvoiceZip}
            </p>
          </div>
          <div class="row">
          <div className='col-md-4 mx-2'>
          {billingResponse?.InvoiceData?.ShowAccounts &&  <>
            For the accounts:
            {billingResponse?.InvoiceData?.LstInvoiceAccounts?.map(item=>
           {
           return <div>
               <p class="fw-medium"> {item.PortfolioName}</p>
             </div>
           }
           )

          }
          </> }
           
          </div>
          </div>
         </div>
         <div class="row">
          <div className='col-md-4'>
          </div>
           <div className='col-md-4'>
           <p class="fw-medium"> Allocations </p>
           </div>
           <div className='col-md-4'>
           <p class="fw-medium"> {GetInvoiceDateQuarterText()+ "Quarter Fee"}</p>
           </div>
           </div>
         <div class="row">
          <div className='col-md-4'>
          <p class="fw-medium"> {GetPrevInvQuarterEndDate()+" Assets Under Management"} </p>
           </div>
           <div className='col-md-4'>
           <SBACurrencyInput
             prefix="$"
                      className="w-100"
                      decimalsLimit={2}
                      value={assetaumdt?.Aumamt}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => {calcadvisoryamt(e) }}
                     
                    />
                    
           {/* <input type="text"
               className="w-100 form-control"
               value={"$"+ currencyValueFormatter(assetaumdt?.Aumamt)}
               style={{textAlign:"Right"}}
               onChange={(e)=>{calcadvisoryamt(e)}}
             /> */}
           </div>
           <div className='col-md-4'>
         
       <SBACurrencyInput
       prefix="$"
                      className="w-100"
                      decimalsLimit={2}
                      value={assetaumdt?.AumFee}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => {calcadvisory(e) }}
                     
                    />
           </div>
          
           </div>
         {monthlydt?.map(item=>
         {
          if(!item.IsStartingAum)
          {
         return  <div class="row">
          <div className='col-md-4'>
      <p class="fw-medium">  {Months[item.AumMonth - 1] + " " + GetYearForInvoiceDate()+ " Investment Activity"} </p>
           </div>
           <div className='col-md-4'>
           {/* <input type="text"
               className="w-100 form-control"
               id={"txt_InvcAumamt_" + item.RowIndex + ""}
               value={item.AumAmount}
               style={{textAlign:"Right"}}
               onChange={(e) => {
                calcAumamtTotal(e,item.RowIndex );
              }}
             /> */}

<SBACurrencyInput

                      className="w-100"
                      decimalsLimit={2}
                      value={item?.AumAmount}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => { calcAumamtTotal(e,item.RowIndex ) }}
                     
                    />
           </div>
           <div className='col-md-4'>
          {/* <input type='text' style={{textAlign:"Right"}} className="w-100 form-control" value={item.AumFee} id={"txt_InvcAumfee_" + item.RowIndex  + ""}
          onChange={(e) => {
            calcAumTotal(e,item.RowIndex );
          }}></input> */}
          
<SBACurrencyInput

                      className="w-100"
                      decimalsLimit={2}
                      value={+ item?.AumFee}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => {calcAumTotal(e,item.RowIndex ) }}
                     
                    />
           </div>
          
           </div>
          }
          //totalFees+=item.AumFee;
          
         }
         )
        
}
<div class="row">
<div className='col-md-4'>
  </div>
  <div className='col-md-4'>
  </div>
         <div className='col-md-4'>
         <hr classname='border border-dark'/>
         {/* <label class="fw-medium">______________________________________</label> */}
         </div>
         </div>

          <div class="row">
         <div className='col-md-4'>
         <p class="fw-medium"> {GetInvoiceDateQuarterText()} Quarter {GetYearForInvoiceDate()} Advisory Fee</p>
          </div>
          <div className='col-md-4'>

          </div>
          <div className='col-md-4'>
          <p style={{textAlign:"Right"}}>
          {CurrencyFormat(advisoryfeetotal)}
          </p>
          </div>
        </div>
        <div class="row">
          <div className='col-md-8'>
            <label class=" col-sm-3 fw-medium mb-0">
              Minus Credit Management Fee directly deducted
            </label>
          </div>
          <div className='col-md-4'>
          <SBACurrencyInput
          
                      className="w-100"
                      decimalsLimit={2}
                      value={creditamount}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => {calccredit(e) }}
                     
                    />

        
            </div>
          </div>

        <div class="row">
          <div className='col-md-8' >
            <label class="fw-medium mb-0">
              PPLI
            </label>
          </div>
          <div className='col-md-4'>
          <SBACurrencyInput
         
                      className="w-100"
                      decimalsLimit={2}
                      value={ppliamount}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => {calcppli(e) }}
                     
                    />
           <hr classname='border border-dark'/>
          <p style={{textAlign:"Right"}}>
          {
            CurrencyFormat(totalamountdue)
          }
          </p>
            </div>
          </div>
          <div class="row">
           <div className='col-md-8'>
             <label class="fw-medium mb-0" >
               {adjustmentLabel + GetInvoiceDateQuarterText() + " Quarter " + GetYearForInvoiceDate()}
             </label>
           </div>
           <div className='col-md-4'>
           </div>
         </div>
          <div class="row">
         <div className='col-md-4'>
        
       <SBADropDown
       className="w-100"
        data={invoiceAdjumentdt}
        textField={"InvoiceAdjustmentText"}
        valueField={"InvoiceAdjustmentId"}
       value={selectedinvoiceadjustment}
        onChange={invoiceadjustmentchange}
       ></SBADropDown>
                                
          </div>
          <div className='col-md-4'></div>
          <div className='col-md-4'>
          <SBACurrencyInput
          
                      className="w-100"
                      decimalsLimit={2}
                      value={invcadjustmentamount}
                      style={{textAlign:"Right"}}
                      onBlur={(e) => {calcAdjustmentAmount(e) }}
                     
                    />
          <hr classname='border border-dark'/>
            </div>
          </div>
          <div class="row">
         <div className='col-md-8'>
        
       <label class="fw-medium mb-0">Amount Due:</label>
                                
          </div>
          <div className='col-md-4'>
          <p style={{textAlign:"Right"}}>
          {CurrencyFormat(grandtotalamountdue)}
          </p>
          <hr classname='border border-dark'/>
          {/* <label class="col-sm-3 fw-medium mb-0">______________________________________</label> */}
          
            </div>
          </div>
          <div class="row">
          <div className='col-md-4'> 
          <label class="fw-medium mb-0">Check should be payable to:</label>

          <p class="fw-medium mb-0"> {billingResponse?.InvoiceData?.PaymentDTO?.PayableTo}</p>
          
            </div>
          </div>
          <div class="row">
          <div className='col-md-2'>
          <label class="fw-medium mb-0">Or wire instructions:</label>
            <p class="fw-medium mb-0">{billingResponse?.InvoiceData?.PaymentDTO?.WireBank}
            {billingResponse?.InvoiceData?.PaymentDTO?.WireABA}
            {billingResponse?.InvoiceData?.PaymentDTO?.WireAccountName}
            {billingResponse?.InvoiceData?.PaymentDTO?.WireAccountNumber}</p>
</div>
</div>
       
      </div>:<div class="row detail  mt-2 gap-2">
      No invoices available for selected date
      </div>
}
    </div>
      {/* Invoice Refresh  Modal ----- */}
      <Modal show={showRefreshModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setshowRefreshModal(false);
          }}
        >
          <Modal.Title>
        Refresh Data
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure that you want to reload the invoice data? Any changes will be lost.</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setshowRefreshModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={()=>{saveInvoiceApproval("delete")}}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
  
     
    <ToastContainer></ToastContainer>
  </>

};



export const BillingPreviewSection=()=>{
  const params=useParams();
  const [billingResponse,setBillingResposne]=useState(null);
  useEffect(()=>{
    getDocuments(params.Date,parseInt(params.Id));
  },[params]);
  const getDocuments = async(billingDate,clientBillingId) => {
    try{
      const response = await sbaAxios({
        url: getBillingDocs,
        params:{
          billingDate: billingDate,
          clientBillingId: clientBillingId
        }
      });
      setBillingResposne(response);
    }
    catch(e){
      setBillingResposne(null);
    }
  };
  const downloadexcel = async () => {
    if (parseInt(params.Id) === 0) {
      SBNotify({
        type: "error",
        Msg: `Please Select the Billing Client`,
      });
      return;
    }
  
    try {
      const approvalDetails = billingResponse?.ApprovalDetails;
  
      if (approvalDetails?.DocumentId == 0) {
        const fileName = `${approvalDetails?.ClientBillingName} ${GetInvoiceDateQuarterText()} ${new Date(params.Date).getFullYear()}.xls`;
  
        const response = await sbaAxios({
          url: getpdfbillingReport,
          params: {
            BillingId: parseInt(params.Id),
            ClientBillingName: approvalDetails?.ClientBillingName,
            BillingDate: params.Date,
          },
          method: 'GET',
          responseType: 'blob',
        });
  
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
  
      } else {
        const documentExtension = "xls";
        const nameWithoutExtension = getFilenameWithoutExtension(approvalDetails?.DocumentName);
        const encodedDocumentId = btoa(approvalDetails?.DocumentId.toString());
        const url = DownloadDocument + encodedDocumentId;
  
        const response = await sbaAxios({
          url,
          responseType: 'blob',
        });
  
        const blob = new Blob([response.data]);
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${nameWithoutExtension}.${documentExtension}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (e) {
      SBNotify({
        type: "error",
        Msg: `Unable to download`,
      });
    }
  };
  
const GetInvoiceDateQuarterText =  ()=> {
  const quarters = ["1st", "2nd", "3rd", "4th"];
  var invDate = new Date(params.Date);
  var quarterNbr = Math.floor((new Date(params.Date).getMonth() + 3) / 3);
  return quarters[quarterNbr - 1];
}
function getFilenameWithoutExtension(filename) {
  return filename.split('.').slice(0, -1).join('.');
}
    return <>
     <div className='row justify-content-end'>
        <div style={{ display: 'flex', alignItems: 'end', width: '250px' }}>
          <span>
            <i
              class="fas fa-file-excel mx-2 m-2 mt-2 SBA_hand"
              style={{ color: "#1D6F42" }}
              onClick={downloadexcel}

            ></i>

          </span>
        </div>
      </div>
      <GeneralAccordian billingResponse={billingResponse} clientBillingId={parseInt(params.Id)}></GeneralAccordian>
             <ToastContainer></ToastContainer>
  </>
}